import React from 'react';

const NAV_ITEMS = ['About Us', 'Social', 'Hours', 'Map', 'Photos', 'Deals', 'Spotlight', 'Reviews', 'Contact'];

function BasicPageNavigation() {
  return (
    <nav id="PageNavigation" aria-label="Single listing sections" className="sr-only">
      {NAV_ITEMS.join(', ')}
    </nav>
  );
}

export default BasicPageNavigation;
